module.exports = __webpack_public_path__ + "static/08-44a0be2719ae82823a6b57c48d036c86.jpg";